import { render, staticRenderFns } from "./importroom.vue?vue&type=template&id=044f7dc6&scoped=true"
import script from "./importroom.vue?vue&type=script&lang=js"
export * from "./importroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f7dc6",
  null
  
)

export default component.exports